// CÓDIGO 100% COMPLETO
export const getStatusPillClass = (status) => {
    switch (status) {
        case 'A Fazer': return 'bg-gray-500/50 text-gray-200';
        case 'Em Progresso': return 'bg-yellow-500/50 text-yellow-200';
        case 'Revisão': return 'bg-blue-500/50 text-blue-200';
        case 'Concluído': return 'bg-emerald-500/50 text-emerald-200';
        default: return 'bg-gray-500/50 text-gray-200';
    }
};

export const getClientStatusPillClass = (status) => {
    switch (status) {
        case 'Ativo': return 'bg-emerald-500/50 text-emerald-200';
        case 'Inativo': return 'bg-gray-500/50 text-gray-200';
        case 'Potencial': return 'bg-sky-500/50 text-sky-200';
        default: return 'bg-gray-500/50 text-gray-200';
    }
};

export const getStatusColor = (status) => {
    switch (status) {
        case 'A Fazer': return '#6b7280';      // gray-500
        case 'Em Progresso': return '#eab308'; // yellow-500
        case 'Revisão': return '#3b82f6';      // blue-500
        case 'Concluído': return '#10b981';    // emerald-500
        default: return '#6b7280';             // gray-500
    }
};

export const getPriorityPillClass = (priority) => {
    switch (priority) {
        case 'Alta': return 'bg-red-500/50 text-red-200';
        case 'Média': return 'bg-yellow-500/50 text-yellow-200';
        case 'Baixa': return 'bg-green-500/50 text-green-200';
        default: return 'bg-yellow-500/50 text-yellow-200';
    }
};

export const getPriorityColor = (priority) => {
    switch (priority) {
        case 'Alta': return '#ef4444'; // red-500
        case 'Média': return '#eab308'; // yellow-500
        case 'Baixa': return '#22c55e'; // green-500
        default: return '#9ca3af'; // gray-400
    }
};

export const getPriorityButtonClass = (priority) => {
    switch (priority) {
        case 'Alta':
            return 'bg-red-500 border-red-400 text-white font-semibold';
        case 'Média':
            return 'bg-yellow-500 border-yellow-400 text-white font-semibold';
        case 'Baixa':
            return 'bg-green-500 border-green-400 text-white font-semibold';
        default:
            return 'bg-gray-500 border-gray-400 text-white font-semibold';
    }
};

export const getDeadlineClass = (deadline) => {
    if (!deadline) return 'text-gray-300';
    const today = new Date();
    const deadlineDateParts = deadline.split('-').map(Number);
    const deadlineDate = new Date(deadlineDateParts[0], deadlineDateParts[1] - 1, deadlineDateParts[2]);
    
    today.setHours(0, 0, 0, 0);
    
    const diffTime = deadlineDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) return 'text-red-400 font-bold';
    if (diffDays === 0) return 'text-yellow-400 font-bold';
    if (diffDays <= 3) return 'text-yellow-400';
    return 'text-gray-300';
};

export const getQuoteStatusPillClass = (status) => {
    switch (status) {
        case 'Rascunho': return 'bg-gray-500/50 text-gray-200';
        case 'Enviado': return 'bg-blue-500/50 text-blue-200';
        case 'Aprovado': return 'bg-emerald-500/50 text-emerald-200';
        case 'Recusado': return 'bg-red-500/50 text-red-200';
        default: return 'bg-gray-500/50 text-gray-200';
    }
};

export const getQuoteStatusColorClass = (status) => {
    switch (status) {
        case 'Rascunho': return 'bg-gray-500';
        case 'Enviado': return 'bg-blue-500';
        case 'Aprovado': return 'bg-emerald-500';
        case 'Recusado': return 'bg-red-500';
        default: return 'bg-gray-500';
    }
};

export const getDaysSinceLastProject = (clientName, tasks) => {
    const clientTasks = tasks.filter(task => task.client === clientName && task.status === 'Concluído' && task.deadline);
    if (clientTasks.length === 0) return null;
    const lastTask = clientTasks.sort((a, b) => new Date(b.deadline) - new Date(a.deadline))[0];
    const lastDate = new Date(lastTask.deadline);
    const today = new Date();
    const diffTime = Math.abs(today - lastDate);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

// --- INÍCIO DA ALTERAÇÃO: Adicionando de volta a função para a etiqueta de alteração ---
export const getAlterationPillClass = (isAlteration) => {
    return isAlteration
        ? 'bg-orange-500/50 text-orange-200'
        : 'bg-gray-500/20 text-gray-300 hover:bg-gray-500/40';
};
// --- FIM DA ALTERAÇÃO ---